import { ToolPageShell } from '@/shared/seo'
import { PodpisatPdfForm } from '@/pages/podpisat-pdf/ui/PodpisatPdfForm'

export function PodpisatPdfPage() {
  return <ToolPageShell utilityKey="sign-pdf"><PodpisatPdfForm /></ToolPageShell>
}
